import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { WarningIcon } from '@10xLabs/react-web/components/Icons/Warning'
import { ReactElement } from 'react'
import { IActivateActionProps } from './types'

const DeactivateWrapper = styled.div<TSFixMe>`
  display: flex;
  align-items: center;
`

const StyledWarningIcon = styled(WarningIcon)<TSFixMe>`
  margin-left: 10px;
`

export const ActivateAction = ({ isActive, error }: IActivateActionProps): ReactElement => (
  <DeactivateWrapper>
    {!isActive ? (
      <FormattedMessage id="dictionary.activate" defaultMessage="Activate" />
    ) : (
      <FormattedMessage id="dictionary.deactivate" defaultMessage="Deactivate" />
    )}

    {error && <StyledWarningIcon />}
  </DeactivateWrapper>
)
